import React from "react";

const EnvironmentId = () => {
  return <div>Environment</div>;
};

export default EnvironmentId;
